<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Program Device",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Program Device",
            items: [
                {
                text: "Device Management",
                href: "/",
                },
                {
                text: "Program Device",
                active: true,
                },
            ],
            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            programDeviceList:[],
            programList:[],
            productList:[],
            uploaded_file:'',
            //loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            disableUpload:true,
            program_id:'',
            tenure:'',
            dtKey:0,
            allSelected:false,
            itemIds:[],
            key_search:null,
            date:null,
            isButtonDisabled:false,
        };
    },
    setup() {
        const permissions = usePermissions();
        
        return {
            permissions,
        };
    },
    methods: {
        submitFile() {
            this.error_country=false;
            this.SeenUpload=false;
            this.isLoadingListDevices=true;
            const formData = new FormData();
            formData.append('uploaded_file', this.Images);
                const headers = { 'Content-Type': 'multipart/form-data' };
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.post(process.env.VUE_APP_API_BASEURL+'import', formData, 
                    { headers }
                ).then((res) => {
                    if (res.data.status == "Success") {
                        // this.programList = res.data;
                        alert('Updated');
                        location.reload();  
                        this.get_program();
                    }else{
                        alert('Product not active');
                    }
                 }
                ).catch(error => {
                    alert(error);
            });
    
        },
        uploadFile() {
            this.Images = this.$refs.file.files[0];
            if(this.Images){
                this.disableUpload = false;
            }
        },
        // downloadExcel: function () {
        //     location.href= process.env.VUE_APP_API_BASEURL+'programdevice/export';
        // },
        downloadExcel: function () {
            //this.export_params = 'date='+this.date+'&key_search='+this.key_search+'&branch_id='+this.branch_id+'&program_id='+this.program_id;
            //location.href= process.env.VUE_APP_API_BASEURL+'customer/export/'+this.export_params;

            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                tenure: this.tenure,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'programdevice/export', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Program Device List.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        resetForm: function () { 
            this.date = null; 
            
            this.tenure = ''; 
            this.program_id= '';
            this.key_search = null; 
            // this.get_program_device_list();
        },

        submitForm(e)
        {
            if (!this.date && !this.key_search && !this.tenure && !this.program_id) {
                alert('Please fill in at least one search field before submitting');
                return '';  // Prevent the form from submitting
            }

            this.isButtonDisabled=true;
            this.ButtonSeen=true;
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                key_search: this.key_search,
                tenure: this.tenure,
                program_id: this.program_id,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'programdevice/search', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.programDeviceList = response.data;
                    this.dtKey +=1;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            })
            .finally(() => {
                this.isButtonDisabled = false;
            });
        },
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },
        get_program_device_list(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program_device/list')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.programDeviceList = response.data;
                    console.log("prog",this.programDeviceList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
           
        },

        //raw data----------------------------------------------------------
        get_program(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'program/raw_data')
            .then(response => {
                if (response) {
                    this.programList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        get_product(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'product/raw_data')
            .then(response => {
                if (response) {
                    this.productList = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        selectAll(){
           this.updateCheckall();
        },
        updateCheckall(){
            this.itemIds = [];
            var checkboxes = document.querySelectorAll(
            '.form-check-all input[type="checkbox"]'
            );
            if (this.allSelected) {
                checkboxes.forEach(function (checkbox) {
                checkbox.checked = true;
                checkbox.closest("tr").classList.add("table-active");
                });
                var prog = this.programDeviceList;
                for (var i = 0; i < prog.length; i++) {
                    this.itemIds.push(prog[i].id);
                }
            } else {
                checkboxes.forEach(function (checkbox) {
                checkbox.checked = false;
                checkbox.closest("tr").classList.remove("table-active");
                });
                this.itemIds = [];
            }

        },
        checkval(item){
            if(this.itemIds.includes(item)){
                const index = this.itemIds.indexOf(item);
                if (index > -1) { // only splice array when item is found
                    this.itemIds.splice(index, 1); // 2nd parameter means remove one item only
                }
            }else{
                this.itemIds.push(item);
            }
        },
        disbaleMultiple(){
            // e.preventDefault()
            // this.itemIds = [];
            // this.itemIds = this.itemIds;
            console.log(this.itemIds);
            const posting_ = {                
                program_id: this.itemIds,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'program/disable_device', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    alert("Updated");
                    this.get_program_device_list();                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },
        enableMultiple(){
            // e.preventDefault()
            // this.itemIds = [];
            // this.itemIds = this.itemIds;
            console.log(this.itemIds);
            const posting_ = {                
                program_id: this.itemIds,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_API_BASEURL+'program/enable_device', posting_)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    alert("Updated");
                    this.get_program_device_list();                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        }
        //raw data----------------------------------------------------------
    },


    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
    },

    mounted() {
        this.get_program_device_list();
        this.get_program();
        this.get_product();
    },

    
};
require("@/assets/css/datatable.css");
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
        <div class="d-flex justify-content-end mb-3">
            <!--button type="button" class="btn btn-primary" @click="click"  v-if="this.role != 3">Add New Branch</button-->
            <!-- <div class=" justify-content-end mb-3"> -->
                <button v-if="permissions.canExport?.value" @click="downloadExcel()" style="height: 40px;" class="btn btn-success"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
                <router-link to="/device/create-program-device" custom v-slot="{ navigate }"><button v-if="permissions.canCreate?.value" class="btn btn-primary ms-1" @click="navigate" role="link"><i class="ri-add-line align-middle me-1"></i> Add New Program Device</button></router-link><br><br>
             
            <!-- </div> -->
            <input style="height: 39px;width: 227px;margin-left: 5px;" type="file" class="form-control" @change="uploadFile" ref="file" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload">
            <button v-if="permissions.canCreate?.value" :disabled='disableUpload' style="height: 40px;" class="btn btn-outline-success" @click="submitFile" type="button" id="inputGroupFileAddon04">Upload</button>
        </div>

        <div class="card-body border-bottom-dashed border-bottom">
                <form @submit.prevent="submitForm" ref="searchCustomer">
                <div class="row g-3">
                    <div class="col-xl-4">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search for Sku,Partner Sku" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-8">
                        <div class="row g-3">
                            <div class="col-sm-5">
                                <div class="">
                                    <flat-pickr v-model="date" placeholder="Select Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                            <!--end col-->
                            <div class="col-sm-4">
                                <div>
                                    <select v-model="tenure" class="form-select mb-4" id="tenure">
                                        <option value="" disabled>Select Tenure</option>
                                        <option value="12">12</option>
                                        <option value="24">24</option>
                                        <option value="36">36</option>
                                        <option value="48">48</option>
                                    </select>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-sm-3">
                                <select v-model="program_id" class="form-select mb-4">
                                    <option value="" disabled>Select Program</option>
                                    <option v-for="(item, index) in programList" :key="index" :value="item.id" >
                                        {{ item.program_name }}
                                    </option>
                                </select>
                            </div>
                            <!--end col-->
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button class="btn btn-soft-danger w-100" v-if="permissions.canCreate?.value || permissions.canUpdate?.value" @click="disbaleMultiple">
                                Disable
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button v-if="permissions.canCreate?.value || permissions.canUpdate?.value" class="btn btn-soft-success w-100" @click="enableMultiple">
                                Enable
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100" :disabled="isButtonDisabled">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                    
                </div>
                <!--end row-->
                </form>
        </div>



        <div class="card">
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable class="table table-striped table-nowrap mb-0" :key="dtKey"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th scope="col" style="width: 25px">
                                                <div class="form-check">
                                                <input class="form-check-input" type="checkbox" @change="selectAll" id="checkAll" v-model="allSelected" />
                                                </div>
                                            </th>
                                            <th>No.</th>
                                            <th scope="col">Program</th>      
                                            <th scope="col">Product</th>      
                                            <th scope="col">SKU</th>
                                            <th scope="col">Partner SKU</th>
                                            <th scope="col">Tenure</th>
                                            <th scope="col">Price</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Created Date</th>
                                            <th scope="col">Created By</th>
                                            <th scope="col">Device Cost</th>
                                            <th scope="col">Program Fee</th>
                                            <th scope="col">MPP</th>
                                            <!--th scope="col">Action</th-->
                                        </tr>
                                    </thead>

                                    <tbody class="list form-check-all">                        
                                        <tr v-for="(item, index) in programDeviceList" :key="index" class="content">
                                            <th scope="row">
                                                <div class="form-check">
                                                    <input class="form-check-input" type="checkbox" :name="'progdv'+index" @click="checkval(item.id)" :value="item.id" v-model="itemIds"/>
                                                </div>
                                            </th>
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.program_name }}</td>                               
                                            <td><router-link :to="'/device/product-details/'+item.product_id" class="fw-medium link-secondary">{{ item.product_name }} </router-link></td>
                                            <!--td>{{ item.product_name }}</td-->
                                            <td><router-link :to="'/device/program-device-details/'+item.id" class="fw-medium link-danger">{{ item.sku }}</router-link></td>
                                            <td>{{ item.partner_sku }}</td>
                                            <td>{{ item.tenure }} MONTHS</td>
                                            <td>RM {{ item.price }}</td>
                                            <td>{{ item.status}}</td>
                                            <td>{{ format_date(item.created_at) }}</td>                                          
                                            <td>{{ item.user_name }}</td> 
                                            <td>{{ item.device_cost }}</td> 
                                            <td>{{ item.program_fee }}</td> 
                                            <td>{{ item.mpp }}</td> 
                                            <!--td>
                                                <i @click="EditBranch(item.id)" class="bx bx-edit" data-bs-toggle="modal" data-bs-target=".editBrand"></i>
                                            </td-->                                         
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>